// extracted by mini-css-extract-plugin
module.exports = {"FormItem":"number_FormItem__36psR"};